import get from 'lodash/get';

export const isEnterKey = e => {
  const which = get(e, 'which');
  const key = get(e, 'key');
  const keyCode = get(e, 'keyCode');

  if (which === 13 || key === 'Enter' || keyCode === 13) return true;

  return false;
};
